import React, { createContext, useContext, useEffect, useState } from "react";
import api, { setToken, clearToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // null = checking, true = authed, false = not authed
  const [authed, setAuthed] = useState(null);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setAuthed(false);
      return;
    }
    api
      .get("/auth/verify")
      .then(() => setAuthed(true))
      .catch(() => {
        clearToken();
        setAuthed(false);
      });
  }, []);

  const login = async (password) => {
    const { data } = await api.post("/auth/login", { password });
    setToken(data.token);
    setAuthed(true);
  };

  const logout = () => {
    clearToken();
    setAuthed(false);
  };

  return (
    <AuthContext.Provider value={{ authed, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
